import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FileObject } from '@thehubz/client/core';
import { AnyType, AssetTypeEnum } from '@thehubz/shared/model';

@Component({
  selector: 'sp-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
})
export class FileListComponent implements OnChanges {
  @Output() filesList = new EventEmitter<{ files: FileObject[] | AnyType[]; removedAsset: AnyType }>();
  @Input() files: FileObject[] | AnyType[] = [];
  @Input() uploadInProgress!: boolean;
  @Input() progress = 0;
  @Input() currentUploadFileName!: string;

  private supportedPreviewTypes = ['png', 'jpeg', 'gif', 'webp', 'avif'];
  private supportedPreivewTypesRegex = new RegExp(`${this.supportedPreviewTypes.join('|')}`, 'i');

  AssetTypeEnum = AssetTypeEnum;

  ngOnChanges(changes: SimpleChanges): void {
    this.createPreviews();
  }

  remove(value: AnyType): void {
    const index = this.files.findIndex((x) => x.name === value.name);
    if (index >= 0 && !value.uploading) {
      this.files.splice(index, 1);
      this.filesList.emit({ files: this.files, removedAsset: value });
    }
  }

  private createPreviews() {
    this.files.forEach((file) => {
      if (this.supportedPreivewTypesRegex.test(file?.file?.type)) {
        this.createPreview(file);
      }
    });
  }

  private createPreview(file: FileObject): void {
    if (!file) return;

    const fileReader = new FileReader();

    fileReader.onload = () => {
      file.previewUrl = fileReader.result as string;
    };

    fileReader.readAsDataURL(file.file);
  }
}
